import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.sidebar');
import { HostListener, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-nav-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.sidebar/view.scss */
/* src/app/component.nav.sidebar/view.scss: no such file or directory */`],
})
export class ComponentNavSidebarComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }

    @HostListener('document:click')
    public clickout() {
        this.service.status.toggle('navbar', true);
    }

    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0;
    }

    public isProjectActive() {
        return this.isActive('/dashboard') || this.isActive('/projects/');
    }

    public activeClass(link: string) {
        if (this.isActive(link)) {
            return 'group flex items-center gap-2 rounded-xl bg-[#e6f3ee] px-2 py-2 text-[11px] font-extrabold text-[#0f766e]';
        }
        return 'group flex items-center gap-2 rounded-xl px-2 py-2 text-[11px] font-bold text-slate-500 transition hover:bg-slate-50 hover:text-slate-800';
    }

    public projectClass() {
        if (this.isProjectActive()) {
            return 'group flex items-center gap-2 rounded-xl bg-[#e6f3ee] px-2 py-2 text-[11px] font-extrabold text-[#0f766e]';
        }
        return 'group flex items-center gap-2 rounded-xl px-2 py-2 text-[11px] font-bold text-slate-500 transition hover:bg-slate-50 hover:text-slate-800';
    }
}

export default ComponentNavSidebarComponent;